import { EChartsOption } from 'echarts';

export const CHART_CONFIG: EChartsOption = {
  animation: false,
  legend: { show: false },
  tooltip: { show: true },
  grid: { left: 6, right: 6, top: 8, bottom: 28 },
  xAxis: { axisLabel: { color: '#9AA2B1', fontSize: 11 }, axisLine: { show: false } },
  yAxis: { show: false, splitLine: { show: true, lineStyle: { type: 'dashed' as const, color: '#EEF0F5' } } },
};

export const PAYBACK_CHART_CONFIG: EChartsOption = {
  ...CHART_CONFIG,
  xAxis: {
    ...CHART_CONFIG.xAxis,
    type: 'value',
    show: false,
  },
  tooltip: { show: false },
};

/**
 * 决策报告-分享权限码：决策概览接口 getYmDecisionReportOverview 返回的 permissions 中
 * 命中该项才在 CommonHeader 右侧展示分享入口
 */
export const DECISION_SHARE_PERMISSION = 'standardChancePoint:saasDecisionShare';

/** 决策报告独立导出权限。 */
export const DECISION_EXPORT_PERMISSION = 'standardChancePoint:saasDecisionExport';

/** 一鸣决策报告独立类型，生成与状态查询必须保持一致。 */
export const DECISION_EXPORT_TYPE = 4;
